export const FETCH_FIXTURE_CIRCUIT_CONFIG = "FETCH_FIXTURE_CIRCUIT_CONFIG";
export const FETCH_FIXTURE_CIRCUIT_CONFIG_PENDING =
  "FETCH_FIXTURE_CIRCUIT_CONFIG_PENDING";
export const FETCH_FIXTURE_CIRCUIT_CONFIG_REJECTED =
  "FETCH_FIXTURE_CIRCUIT_CONFIG_REJECTED";
export const FETCH_FIXTURE_CIRCUIT_CONFIG_FULFILLED =
  "FETCH_FIXTURE_CIRCUIT_CONFIG_FULFILLED";
